import React, { Fragment } from 'react';

export default {
  share: {
    viewBox: '0 0 24 24',
    width: 24,
    height: 24,
    body: () => (
      <path d="M3.4 20.4L20.85 12.92C21.66 12.57 21.66 11.43 20.85 11.08L3.4 3.6C2.74 3.31 2.01 3.8 2.01 4.51L2 9.12C2 9.62 2.37 10.05 2.87 10.11L17 12L2.87 13.88C2.37 13.95 2 14.38 2 14.88L2.01 19.49C2.01 20.2 2.74 20.69 3.4 20.4Z" />
    ),
  },
  shared: {
    viewBox: '0 0 24 24',
    width: 24,
    height: 24,
    body: () => (
      <Fragment>
        <g clipPath="url(#clip0_630_3)">
          <path d="M16.5 9C16.08 9 15.67 9.04 15.26 9.11L2.4 3.6C1.74 3.31 1.01 3.8 1.01 4.51L1 9.2C1 9.67 1.33 10.08 1.78 10.18L10 12L1.78 13.83C1.33 13.93 1 14.33 1 14.8L1.01 19.48C1.01 20.2 1.74 20.68 2.4 20.4L9.08 17.54C9.59 21.19 12.71 24 16.5 24C20.64 24 24 20.64 24 16.5C24 12.36 20.64 9 16.5 9ZM16.5 22C13.47 22 11 19.53 11 16.5C11 13.47 13.47 11 16.5 11C19.53 11 22 13.47 22 16.5C22 19.53 19.53 22 16.5 22Z" />
          <path d="M15.0135 19.3729C15.387 19.7476 15.9902 19.7476 16.3636 19.3729L20.4235 15.2896C20.7969 14.9149 20.7969 14.3096 20.4235 13.9349C20.0501 13.5602 19.4468 13.5602 19.0734 13.9349L15.6838 17.336L14.3337 15.9814C13.9603 15.6067 13.3571 15.6067 12.9836 15.9814C12.6102 16.3561 12.6102 16.9613 12.9836 17.336L15.0135 19.3729Z" />
        </g>
        <defs>
          <clipPath id="clip0_630_3">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </Fragment>
    ),
  },
  allow_continue: {
    viewBox: '-2 0 20 20',
    width: 16,
    height: 16,
    body: () => (
      <Fragment>
        <rect fill="white" />
        <path
          d="M8.2 9.32313C7.21 9.32313 6.3625 8.97063 5.6575 8.26563C4.9525 7.56063 4.6 6.71313 4.6 5.72313C4.6 4.73313 4.9525 3.88563 5.6575 3.18063C6.3625 2.47563 7.21 2.12313 8.2 2.12313C9.19 2.12313 10.0375 2.47563 10.7425 3.18063C11.4475 3.88563 11.8 4.73313 11.8 5.72313C11.8 6.71313 11.4475 7.56063 10.7425 8.26563C10.0375 8.97063 9.19 9.32313 8.2 9.32313ZM1 16.5231V14.0031C1 13.4781 1.13125 13.0056 1.39375 12.5856C1.65625 12.1656 2.005 11.8431 2.44 11.6181C3.37 11.1531 4.315 10.8044 5.275 10.5719C6.235 10.3394 7.21 10.2231 8.2 10.2231C8.83 10.2231 9.45625 10.2719 10.0787 10.3694C10.7013 10.4669 11.3275 10.6131 11.9575 10.8081C10.9675 11.4081 10.3525 12.2669 10.1125 13.3844C9.8725 14.5019 10.0675 15.5481 10.6975 16.5231H1Z"
          fill="#52525B"
        />
        <path
          d="M13.9883 16.6539L15.2877 17.8769L19.0002 14.3828L15.2877 10.8886L13.9883 12.1116L15.4501 13.5092H11.5752V15.2563H15.4501L13.9883 16.6539Z"
          fill="#52525B"
        />
      </Fragment>
    ),
  },
  bulk_delete: {
    viewBox: '0 0 16 18',
    width: 16,
    height: 18,
    body: () => (
      <path
        d="M14.5283 9.25C14.7727 9.25005 14.9822 9.33672 15.1562 9.51074C15.3303 9.68476 15.4169 9.89432 15.417 10.1387V16.3613C15.4169 16.6057 15.3303 16.8152 15.1562 16.9893C14.9822 17.1633 14.7727 17.2499 14.5283 17.25H8.30566C8.06131 17.2499 7.85176 17.1633 7.67773 16.9893C7.50371 16.8152 7.41704 16.6057 7.41699 16.3613V10.1387C7.41704 9.89432 7.50371 9.68476 7.67773 9.51074C7.85176 9.33672 8.06131 9.25005 8.30566 9.25H14.5283ZM10.084 3.66699C11.0922 3.66715 11.917 4.49176 11.917 5.5V8.25H7.41699C6.86471 8.25 6.41699 8.69772 6.41699 9.25V16.5H2.75C1.74194 16.4998 0.91717 15.6751 0.916992 14.667V5.5C0.916992 4.49179 1.74183 3.66719 2.75 3.66699H10.084ZM10.7949 13.8721L9.52832 12.6055L8.90625 13.2275L10.7949 15.1162L13.9277 11.9834L13.3057 11.3613L10.7949 13.8721ZM8.33301 0C8.57126 4.01394e-05 8.80964 0.100697 8.97461 0.265625L9.625 0.916992H11.917C12.4211 0.916992 12.8338 1.32899 12.834 1.83301C12.834 2.33717 12.4212 2.75 11.917 2.75H0.916992C0.412844 2.74998 0 2.33716 0 1.83301C0.000177457 1.329 0.412953 0.917014 0.916992 0.916992H3.20898L3.85938 0.265625C4.02432 0.100691 4.26273 6.2689e-05 4.50098 0H8.33301Z"
        fill="currentColor"
      />
    ),
  },
};
